import request from '@/network/http'

export function getOrganizationTypeList() {
    return request({
        url: 'Base/Organization/getOrganizationTypeList',
        method: 'post',
    })
}

export function getEvaluationTypeList() {
    return request({
        url: 'Base/CheckupProject/getEvaluationTypeList',
        method: 'post',
    })
}

export function getCheckupProjectTypeList() {
    return request({
        url: 'Base/CheckupProject/getCheckupProjectTypeList',
        method: 'post',
    })
}

export function getActionPeriodList() {
    return request({
        url: 'Base/CheckupProject/getActionPeriodList',
        method: 'post',
    })
}

export function getUserList(data) {
    return request({
        url: 'Users/OrganizationUsers/getUserList',
        method: 'post',
        data
    })
}

export function getNextLevelOrganizationList() {
    return request({
        url: 'Organization/Organization/getNextLevelOrganizationList',
        method: 'post',
    })
}


// WEBPACK FOOTER //
// ./src/apis/info.js